// src/components/Modal.js
import React from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ isOpen, onClose, children, size = 'wide' }) {
  if (!isOpen) {
    return null;
  }

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  // createPortal телепортирует верстку в document.body, 
  // полностью изолируя ее от скролла и CSS-фильтров родительской модалки
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className={`modal-content modal-size-${size}`} 
        onClick={handleContentClick}
      >
        <button className="modal-close-button" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
}